<template>
  <div class="editor-ui">
    <div class="title">Templates</div>
    <select class="input" @change="loadTemplate">
      <option v-for="option in ornamentType.options" :value="option.value">{{ option.text }}</option>
    </select>
  </div>
</template>

<script>

export default {

  name: 'editor-ui',

  data: function () {
    return {
      sound: {},
      ornamentType: {
        options: [
          { text: 'Abc music notation', value: 'template.abc' },
          { text: 'Humdrum **kern', value: 'template.krn' },
          { text: 'MusicXML', value: 'template.musicxml' },
          { text: 'MuseData representation', value: 'template.muse' }
        ]
      }
    }
  },

  mounted: function () {
  },

  methods: {

    loadTemplate: function(evt) {
      var self = this
      var file = `./resources/templates/${evt.target.value}/`
      fetch(file)
        .then(function (response) {
          return response.text()
        })
        .then(function (template) {
          self.$root.$emit('setTemplate', template)
        })
    }
  }

}

</script>

<style scoped>

.title {
  font-weight: 800;
  color: white;
  background-color: #303a44;
  border-radius: 3px;
  margin-top: 7px;
  padding-left: 3px;
  margin-bottom: 5px;
}

.input {
  width: 100%;
}

.editor-ui {
  font-size: 10pt;
  background-color: #eee;
  border-left: 1px solid #ddd;
  padding: 10px;
  overflow: scroll;
  -webkit-overflow-scrolling: touch;
}


</style>
